// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1GZ8x","footer":"ReportModalFilter_footer__2HZMU"};